import { get, isEmpty } from 'lodash'
import { chatFlowNodeCategories } from '../../constants/chatFlowNodes'
import { AvailableNode, Node } from '@constants/agentBuilderTypes'
import { InternalMessage } from '@slices/userMessage'

export const getMessageAction = (message: InternalMessage) => {
  const tool: { name?: string; label?: string; id?: string } = get(message, 'data.tool', {})
  // TODO: this does not seem right, neither toolInput or log exist on WebsocketMessageData
  const input = get(message, 'data.toolInput') || get(message, 'data.log', '')
  if (isEmpty(tool) || isEmpty(input)) {
    return null
  }
  return {
    tool,
    input,
  }
}

export const getNodesByCategory = (chatFlowData: { nodes: Node[] }, category: string) => {
  const usedNodes: string[] = []
  if (!chatFlowData?.nodes) return []
  return chatFlowData?.nodes.filter(node => {
    const isValid = node?.data.category === category && !usedNodes.includes(node.data.name)
    usedNodes.push(node.data.name)
    return isValid
  })
}

export const getAllNodeTypes = (flowData: { nodes: Node[] }) => {
  const tools = getNodesByCategory(flowData, chatFlowNodeCategories.TOOL)
  const vectorStores = getNodesByCategory(flowData, chatFlowNodeCategories.VECTOR_STORES)
  const llms = getNodesByCategory(flowData, chatFlowNodeCategories.LLM)
  const chainLlms = getNodesByCategory(flowData, chatFlowNodeCategories.CHAIN_LLM)
  const chatModels = getNodesByCategory(flowData, chatFlowNodeCategories.CHAT_MODELS)
  const agentTypes = getNodesByCategory(flowData, chatFlowNodeCategories.AGENT)
  const chains = getNodesByCategory(flowData, chatFlowNodeCategories.CHAIN)

  return {
    tools: tools.map(tool => tool.data.name),
    vectorStores: vectorStores.map(vectorStore => vectorStore.data.name),
    agentTypes: agentTypes.map(agentType => agentType.data.name),
    allModels: [...llms, ...chatModels, ...chainLlms].map(model => model.data.name),
    chains: chains.map(chain => chain.data.name),
  }
}

/**
 * Marks nodes as deprecated if they are not found in the available nodes pool.
 * Mutates the nodes array in place.
 * @param {Array} nodes - The nodes to check
 * @param {Array} availableNodes - The available nodes from the server
 * @param {string} [chatflowId] - Optional chatflow ID for logging
 */
export const markDeprecatedNodes = (nodes: Node[], availableNodes: AvailableNode[], chatflowId?: string) => {
  if (!nodes || !availableNodes?.length) {
    return
  }

  for (const node of nodes) {
    const serverNode = availableNodes.find(n => n.name === node.data.name)
    if (!serverNode && node.permitted !== false) {
      node.data.isDeprecated = true
      if (chatflowId) {
        console.warn(`Chatflow ${chatflowId} contains a deprecated node: ${node.data.name}.`)
      }
    }
  }
}
